import classnames from 'classnames';
import { FC } from 'react';

import { failureCodes, successCodes } from './utils';

type LogStatusCodeProps = {
  responseStatus: number | string;
};

export const LogStatusCode: FC<LogStatusCodeProps> = ({ responseStatus }) => {
  return (
    <span
      className={classnames('font-medium', {
        'text-green-500': successCodes.includes(Number(responseStatus)),
        'text-red-500': failureCodes.includes(Number(responseStatus)),
      })}
    >
      {responseStatus}
    </span>
  );
};
